module.exports = __webpack_public_path__ + "img/miri_img03.9ba52079.png";